import React, { Component } from 'react';
import PropTypes from 'prop-types';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import { withStyles } from '@material-ui/core/styles';
import withWidth from '@material-ui/core/withWidth';
import moment from 'moment';
import ValueSelection from './ValueSelection';

const styles = theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    whiteSpace: 'nowrap',
    alignItems: 'center',
    marginBottom: 10,
    marginTop: 10,
    flexWrap: 'wrap',
  },
  partOfHalfRow: {
    width: '50%',
  },
  halfFormRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '50%',
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
    alignItems: 'center',
    minWidth: 276,
    justifyContent: 'space-evenly',
  },
});

export class AdvancedSearchForm extends Component {
  constructor(props) {
    super(props);

    this.handleTargetChange = this.handleTargetChange.bind(this);
    this.handleAttributeChange = this.handleAttributeChange.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.removeFilter = this.removeFilter.bind(this);
    this.getDefaultValue = this.getDefaultValue.bind(this);
    this.getAttributeLabel = this.getAttributeLabel.bind(this);
  }

  getDefaultValue(attributeName) {
    const { attributes } = this.props;
    const formInputType = attributes
      .find(attribute => attribute.field_name === attributeName).form_input_type;
    let defaultValue;
    switch (formInputType) {
      case 'text':
        defaultValue = '';
        break;
      case 'number':
        defaultValue = 0;
        break;
      case 'slider':
        defaultValue = [0, 0];
        break;
      case 'date':
        defaultValue = ['1900-01-01', moment().format('YYYY-MM-DD')];
        break;
      case 'select':
        [defaultValue] = attributes
          .find(attribute => attribute.field_name === attributeName).options;
        break;
      default:
        defaultValue = '';
        break;
    }
    return defaultValue;
  }

  getAttributeLabel(attributeFieldName) {
    let label;
    switch (attributeFieldName) {
      case 'num':
        label = 'MTE number';
        break;
      case 'captive':
        label = 'captive/wild';
        break;
      case 'offspring count':
        label = 'calves';
        break;
      default:
        label = attributeFieldName;
        break;
    }
    return label;
  }

  handleTargetChange(event) {
    const { filter, updateFilter } = this.props;
    const updatedFilter = { ...filter, target: event.target.value };
    updateFilter(updatedFilter);
  }

  handleAttributeChange(event) {
    const { filter, updateFilter } = this.props;
    const value = this.getDefaultValue(event.target.value);
    const updatedFilter = { ...filter, attribute: event.target.value, value };
    updateFilter(updatedFilter);
  }

  handleValueChange(value) {
    const { filter, updateFilter } = this.props;
    const updatedFilter = { ...filter, value };
    updateFilter(updatedFilter);
  }

  removeFilter() {
    const { removeFilter, filter } = this.props;
    removeFilter(filter.index);
  }


  render() {
    const {
      filter, queryTargets, attributes, classes, filterAmount,
    } = this.props;
    const currentAttribute = attributes
      .find(attribute => attribute.field_name === filter.attribute);
    const formInputType = currentAttribute.form_input_type;
    const options = formInputType === 'select' ? currentAttribute.options : [''];
    return (
      <div className={classes.root}>
        <div className={classes.halfFormRow}>
          <div className={classes.partOfHalfRow}>
            <FormControl>
              <InputLabel htmlFor="target-id">
                {'Target'}
              </InputLabel>
              <Select
                inputProps={{ name: 'target', id: 'target-id' }}
                className={classes.select}
                value={filter.target}
                onChange={this.handleTargetChange}
              >
                {queryTargets.map(queryTarget => (
                  <MenuItem key={queryTarget} value={queryTarget}>
                    {queryTarget}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className={classes.partOfHalfRow}>
            <FormControl>
              <InputLabel htmlFor="attribute-id">
                {'Attribute'}
              </InputLabel>
              <Select
                inputProps={{ name: 'attribute', id: 'attribute-id' }}
                value={filter.attribute}
                onChange={this.handleAttributeChange}
              >
                {attributes.map(attribute => (
                  <MenuItem key={attribute.field_name} value={attribute.field_name}>
                    {this.getAttributeLabel(attribute.field_name)}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
        </div>
        <div className={classes.halfFormRow}>
          <div className={classes.partOfHalfRow}>
            <ValueSelection
              fieldName={currentAttribute.field_name}
              formInputType={formInputType}
              updateFilter={this.handleValueChange}
              value={filter.value}
              options={options}
            />
          </div>
          <div className={classes.partOfHalfRow}>
            <div>
              <Button
                onClick={this.removeFilter}
                variant="contained"
                className={classes.removeButton}
                disabled={filterAmount === 1}
              >
                {'Remove filter'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

AdvancedSearchForm.propTypes = {
  filter: PropTypes.shape().isRequired,
  removeFilter: PropTypes.func.isRequired,
  queryTargets: PropTypes.arrayOf(PropTypes.string).isRequired,
  attributes: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  updateFilter: PropTypes.func.isRequired,
  classes: PropTypes.shape().isRequired,
  filterAmount: PropTypes.number.isRequired,
};

export default withWidth()(withStyles(styles)(AdvancedSearchForm));



// WEBPACK FOOTER //
// ./src/components/search/advanced-search/AdvancedSearchForm.jsx